import { RootState } from "@/store/store";
import { explainWithAiWidgetIdSelector } from "@/store/explain-with-ai/selectors/slice-data/explainWithAiWidgetIdSelector";
import { getExplainWithAiByWidgetIdSelector } from "@/store/explain-with-ai/selectors/data/dashboard/getExplainWithAiByWidgetIdSelector";

import { getBillingExplorerSummarySelector } from "@/store/explain-with-ai/selectors/data/billing-explorer/getBillingExplorerSummarySelector";
import { explainWithAIBillingDataSelector } from "@/store/explain-with-ai/selectors/slice-data/explainWithAIBillingDataSelector";

export const explainWithAiLoadingSelector = (
  state: RootState,
  index: number,
) => {
  const widgetId = explainWithAiWidgetIdSelector(state);

  if (widgetId) {
    return getExplainWithAiByWidgetIdSelector({ widgetId })(state)?.isLoading;
  }
  const data = explainWithAIBillingDataSelector(state);
  const key = data?.[+index]?.key;
  return getBillingExplorerSummarySelector(key ?? "")(state)?.isLoading;
};
